// src/components/Admin/Finance/SalesFilters.js
import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Grid, MenuItem, TextField } from "@mui/material";

const STATUS = ["draft","open","invoiced","paid","canceled"];
const SERVICE_TYPES = ["web","branding","ads","support","other"];
const CURRENCIES = ["PEN","USD"];

export function SalesFilters({ onChange }) {
  const [form, setForm] = useState({
    search: "",               // SearchFilter: description, client__name (back soporta)
    status: "",               // exact
    service_type: "",         // exact
    currency: "",             // exact
    invoiced: "",             // true/false
    issue_date_after: "",
    issue_date_before: "",
  });

  // debounce simple para búsqueda
  const [search, setSearch] = useState("");
  useEffect(() => { const t = setTimeout(() => setForm((f) => ({ ...f, search })), 350); return () => clearTimeout(t); }, [search]);

  const params = useMemo(() => {
    const p = {};
    if (form.search) p.search = form.search;
    if (form.status) p.status = form.status;
    if (form.service_type) p.service_type = form.service_type;
    if (form.currency) p.currency = form.currency;
    if (form.invoiced) p.invoiced = form.invoiced; // "true" | "false"
    if (form.issue_date_after) p["issue_date_after"] = form.issue_date_after;
    if (form.issue_date_before) p["issue_date_before"] = form.issue_date_before;
    p.ordering = "-created_at";
    return p;
  }, [form]);

 useEffect(() => { onChange?.(params); }, [params]);

  const onReset = () => {
    setForm({
      search: "", status: "", service_type: "", currency: "", invoiced: "", issue_date_after: "", issue_date_before: "",
    });
    onChange?.({ ordering: "-created_at" });
  };

  return (
    <Box mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField label="Buscar (cliente/descr.)" size="small" fullWidth value={search} onChange={(e) => setSearch(e.target.value)} />
        </Grid>
        <Grid item xs={6} md={2}>
          <TextField select label="Estado" size="small" fullWidth value={form.status} onChange={(e)=>setForm(f=>({...f,status:e.target.value}))}>
            <MenuItem value="">Todos</MenuItem>
            {STATUS.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6} md={2}>
          <TextField select label="Servicio" size="small" fullWidth value={form.service_type} onChange={(e)=>setForm(f=>({...f,service_type:e.target.value}))}>
            <MenuItem value="">Todos</MenuItem>
            {SERVICE_TYPES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6} md={2}>
          <TextField select label="Moneda" size="small" fullWidth value={form.currency} onChange={(e)=>setForm(f=>({...f,currency:e.target.value}))}>
            <MenuItem value="">Todas</MenuItem>
            {CURRENCIES.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={6} md={1.5}>
          <TextField select label="Facturado" size="small" fullWidth value={form.invoiced} onChange={(e)=>setForm(f=>({...f,invoiced:e.target.value}))}>
            <MenuItem value="">Todos</MenuItem>
            <MenuItem value="true">Sí</MenuItem>
            <MenuItem value="false">No</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={6} md={1.5}>
          <TextField label="Desde" type="date" size="small" fullWidth value={form.issue_date_after} onChange={(e)=>setForm(f=>({...f,issue_date_after:e.target.value}))} />
        </Grid>
        <Grid item xs={6} md={1.5}>
          <TextField label="Hasta" type="date" size="small" fullWidth value={form.issue_date_before} onChange={(e)=>setForm(f=>({...f,issue_date_before:e.target.value}))} />
        </Grid>
        <Grid item xs={12} md={1.5} display="flex" alignItems="center">
          <Button onClick={onReset}>Limpiar</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
